<template>
  <div class="animated fadeIn">
    <div class="card lich-bieu">
      <div class="card-body">
        <h3
          class="uppercase text-center mt-2"
          style="
            color: #0064b2;
            font-family: 'Times new roman';
            font-weight: bold;
          "
        >
          CHÀO MỪNG ĐẾN VỚI TRANG QUẢN TRỊ CHƯƠNG TRÌNH ĐĂNG KÝ, KHAI BÁO AN TOÀN COVID-19
        </h3>
        <h3
          class="uppercase text-center mt-2"
          style="
            color: #4dbd74;
            font-family: 'Times new roman';
            font-weight: bold;`
            margin-bottom: 50px;
          "
        >
          MỨC ĐỘ AN TOÀN COVID HÀNG NGÀY
        </h3>
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <div class="form-status">
            <el-form-item 
              label="TRẠNG THÁI HIỆN TẠI CỦA CƠ SỞ" 
              prop="ngung_hoat_dong"
            >
            
                  <!-- <el-checkbox
                    class="checkbox-inactive"
                    :disabled ="mData.notAllowToChange"
                    v-model="mData.dataForm.hoat_dong.ngung_hoat_dong"
                    @change="fn_chuyenTrangThaiHoatDong(mData.dataForm.hoat_dong.ngung_hoat_dong)"
                  >Cơ sở tạm ngừng hoạt động</el-checkbox> -->
                  <el-radio
                    class="checkbox-active-lich"
                    v-model='mData.dataForm.hoat_dong.ngung_hoat_dong'
                    @change="fn_chuyenTrangThaiHoatDong(false)"
                    :label="false"
                    :disabled="mData.notAllowToChange"
                  >Hoạt động</el-radio>
                  <el-radio
                    class="checkbox-inactive-lich"
                    v-model='mData.dataForm.hoat_dong.ngung_hoat_dong'
                    @change="fn_chuyenTrangThaiHoatDong(true)"
                    :label="true"
                    :disabled="mData.notAllowToChange"
                  >Ngừng hoạt động</el-radio>
                  <div class="status-title" v-if="mData.notAllowToChange">
                    {{(mData.dataForm.hoat_dong && mData.dataForm.hoat_dong.thoi_diem_thay_doi_cuoi ? 'Cơ sở kinh doanh chỉ được thay đổi trạng thái sau 7 ngày tính từ: ' + new Intl.DateTimeFormat('vi-VN',options).format(new Date(mData.dataForm.hoat_dong.thoi_diem_thay_doi_cuoi))  : '')}}
                  </div>
            </el-form-item>
          </div>
        </el-form>
        <FunctionalCalendar
          :markedDates="markedDates"
          :is-multiple='true'
          :calendars-count='4'
          :change-month-function="true"
          :change-year-function="true"
          :date-format="'dd-mm-yyyy'"
          :hidden-elements="['leftAndRightDays']"
          ref="Calendar"
          @changedMonth="changedMonth"
          :newCurrentDate="date"
          :dayNames="dayNames"
          :monthNames="monthNames"
          @dayClicked="dayClicked"
        >
        </FunctionalCalendar>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="'THÔNG TIN KHAI BÁO NGÀY ' + mData.selectedDay.date"
      :visible.sync="mData.dialog.dayInfo"
      top="85px"
      font-size="13px"
      height="auto"
      style="max-width: 100%"
    >
      <template slot="title">
        <div class="el-dialog-title" style="margin-bottom:0;">
           <span class="title">THÔNG TIN KHAI BÁO NGÀY {{mData.selectedDay.date}} </span> 
        </div>
      </template>
      <div class="card-body">
          <b-row>
            <b-col md="4" cols="4" style="word-break: normal;">Tài khoản</b-col>
            <b-col md="8" cols="8" style="word-break: normal;">{{mData.selectedDay.account}}</b-col>
          </b-row>
          <b-row>
            <b-col md="4" cols="4" style="word-break: normal;">Trạng thái</b-col>
            <b-col md="8" cols="8" style="word-break: normal;">{{mData.selectedDay.ngung_hoat_dong == true  ? "Ngừng hoạt động" : "Hoạt động"}}</b-col>
          </b-row>
          <b-row v-if="!mData.selectedDay.status">
            <b-col md="4" cols="4" style="word-break: normal;">Khai báo</b-col>
            <b-col md="8" cols="8" style="word-break: normal;">Chưa khai báo</b-col>
          </b-row>
          <b-row v-if="mData.selectedDay.status">
            <b-col md="4" cols="4" style="word-break: normal;">Loại</b-col>
            <b-col md="8" cols="8" style="word-break: normal;">{{mData.selectedDay.type}}</b-col>
          </b-row>
          <b-row v-if="mData.selectedDay.status">
            <b-col md="4" cols="4" style="word-break: normal;">Đạt</b-col>
            <b-col md="8" cols="8" style="word-break: normal;">{{mData.selectedDay.count}}/{{mData.selectedDay.max}} tiêu chí</b-col>
          </b-row>
          <b-row>
            <b-col md="4" cols="4" style="word-break: normal;">Xếp loại</b-col>
            <b-col md="8" cols="8" style="word-break: normal;">{{mData.selectedDay.status == 1 ? "An toàn" : mData.selectedDay.status == 2 ? "Có nguy cơ" : "Chưa đáp ứng"}}</b-col>
          </b-row>
          <b-row v-if="mData.selectedDay.status">
            <b-col md="4" cols="4" style="word-break: normal;">Thời điểm</b-col>
            <b-col md="8" cols="8" style="word-break: normal;">{{mData.selectedDay.time}}</b-col>
          </b-row>
          <b-row v-if="mData.selectedDay.status">
            <b-col md="4" cols="4" style="word-break: normal;">Trạng thái dịch</b-col>
            <b-col md="8" cols="8" style="word-break: normal;">{{mData.selectedDay.max > 10 ? "Có dịch" : "An toàn"}} <em>(tại thời điểm khai báo)</em></b-col>
          </b-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import { FunctionalCalendar } from 'vue-functional-calendar';
import DiemDenAnToanApi from '../../../moduleApi/DiemDenAnToanApi';
import MethodService from '../../../service/MethodService';
import DataService from '../../../service/DataService';
import DiemDenAnToanModel from '@/views/admin/DiemDenAnToan/DiemDenAnToanModel';
import moment from "moment";

export default {
  name: "LichBieuKBAT",
  components: {
    FunctionalCalendar
  },
  data: function () {
    let user = MethodService.getCurrentUser();
    return {
      aLang: LanguageService.lang,
      mData: {
        selectedDay: {
          date: "",
          account: user ? user.account : "",
          status: "",
          type: "",
          count: 0,
          max: 0,
          time: "",
          ngung_hoat_dong: ""
        },
        dialog: {
          dayInfo: false
        },
        dataForm: MethodService.copyObject(DiemDenAnToanModel.dataForm),
        notAllowToChange: false,
      },
      ddat: null,
      markedDates: [],
      calendarConfigs: {
        hiddenElements:['leftAndRightDays'],
      },
      date: null,
      dayNames: ["T2","T3","T4","T5","T6","T7","CN"],
      monthNames: ["Tháng 1","Tháng 2","Tháng 3","Tháng 4","Tháng 5","Tháng 6","Tháng 7","Tháng 8","Tháng 9","Tháng 10","Tháng 11","Tháng 12"]
    };
  },
  created() {
    let dt = new Date();
    dt.setHours(0,0,0,0);
    dt.setDate(1);
    dt.setMonth(dt.getMonth() - 3);
    this.date = dt;
    this.getDeclaredStatusCalendar(dt);
    this.getStatusActive();
  },
  methods: {
    async getStatusActive(){
      let currentUser = MethodService.getCurrentUser();
      let dataFilter = {
        filters: "nguoi_tao_id:in:" + currentUser.id
      };
      DiemDenAnToanApi.clearCache();
      let res = await DiemDenAnToanApi.list(dataFilter);
      if(res.result && res.result.length > 0){
        this.mData.dataForm =  res.result[0];
        if(res.result[0].hoat_dong == undefined || res.result[0].hoat_dong.ngung_hoat_dong == undefined){
          this.mData.dataForm.hoat_dong = {ngung_hoat_dong:false};
        }else{
          this.mData.dataForm.hoat_dong.ngung_hoat_dong =  res.result[0].hoat_dong.ngung_hoat_dong;
        }
        if(res.result[0].hoat_dong == undefined || res.result[0].hoat_dong.thoi_diem_thay_doi_cuoi == undefined){
          this.mData.notAllowToChange = false;
        }else{
          this.mData.dataForm.hoat_dong.thoi_diem_thay_doi_cuoi = res.result[0].hoat_dong.thoi_diem_thay_doi_cuoi;
          let todayTime = new Date().getTime();
          let lastTimeChange = new Date(res.result[0].hoat_dong.thoi_diem_thay_doi_cuoi).getTime();
          let totalTimeChange = (todayTime -  lastTimeChange)/1000/60/60/24;
          if(totalTimeChange < 7){
            this.mData.notAllowToChange = true;
          }else{
            this.mData.notAllowToChange = false;
          }
        }
      }
      console.log("this.mData.dataForm",this.mData.dataForm);
    },
    async getDeclaredStatusCalendar(startDate) {
      try {
        let user = MethodService.getCurrentUser();
        let dateRange = this.getDateRange(startDate);

        if (!this.ddat) {
          let ddats = await DiemDenAnToanApi.list({
            filters: ["nguoi_tao_id=$$user_id"],
            fields: "id,loai_diem_den,nguoi_tao_id,thoi_diem_tao,hoat_dong",
            limit: 1
          });
          if (ddats.result.length) {
            this.ddat = ddats.result[0];
          }
        }

        let createdTime = 0;
        if (this.ddat && this.ddat.thoi_diem_tao) {
          let d = new Date(this.ddat.thoi_diem_tao);
          d.setMilliseconds(0);
          d.setSeconds(0);
          d.setMinutes(0);
          d.setHours(0);
          createdTime = d.getTime();
        }
        let day = Math.max(new Date(2020, 10, 9, 0, 0).getTime(), createdTime);

        const declaredStatusCalender = new Date(dateRange.to).getTime() < day || new Date(dateRange.from).getTime() > new Date().getTime()
          ? {code: 0, result: []} 
          : await DiemDenAnToanApi.declaredStatusCalendar({
            dd_account: user.account,
            from: dateRange.from,
            to: dateRange.to,
          });
           this.processMarkedDate(dateRange, declaredStatusCalender.result, this.ddat.hoat_dong ? this.ddat.hoat_dong.lich_su_thay_doi : null);
        
      } catch (error) {
        console.log('error', error)
      }
    },
    getFormatedDate(date) {
      let d = new Date(date);
      let dd = d.getDate();
      let mm = d.getMonth() + 1;
      let y = d.getFullYear();

      return dd + "-" + mm + "-" + y;
    },
    getDateRange(startDate) {
      let d = new Date(startDate);
      //let fromDate = moment(d).format("YYYY-MM-DDTHH:mm:ssZ");
      let fromDate = d.toISOString();
      d.setMonth(d.getMonth() + 4);
      //let toDate = moment(d).format("YYYY-MM-DDTHH:mm:ssZ");
      let toDate = d.toISOString();
      return  { from: fromDate, to: toDate };
    },
    processMarkedDate(today, declaredCalendar, historyChange) {
      let createdTime = 0;
      if (this.ddat && this.ddat.thoi_diem_tao) {
        let d = new Date(this.ddat.thoi_diem_tao);
        d.setMilliseconds(0);
        d.setSeconds(0);
        d.setMinutes(0);
        d.setHours(0);
        createdTime = d.getTime();
      }
      let day = Math.max(new Date(2020, 10, 9, 0, 0).getTime(), new Date(today.from).getTime(), createdTime);
      let to = Math.min(new Date().getTime(), new Date(today.to).getTime());
      declaredCalendar.forEach(item => item._time = new Date(item.date).getTime());
      while (day <= to)
      {
        let dateItem = declaredCalendar.find(item => item._time == day);
        let className;
        let inactive = false;
        if(this.isUnacitve(dateItem ? new Date(dateItem.time).getTime() : day, historyChange)){
          className = "unactive";
          inactive = true;
        } else if (dateItem) {
          switch (dateItem.status) {
            case 1: 
              className = "safe";
              break;
            case 2: 
              className = "risky";
              break;
            case 3: 
              className = "not-safe";
              break;
          }
          if(dateItem.ngung_hoat_dong == true){
            className = "unactive";
            inactive = true;
          }
        } else {
          className = "not-safe not-declared";
        }

        let date = this.getFormatedDate(day);
        var markedDateItem = this.markedDates.find(item => item.date == date);
        if (markedDateItem) {
          markedDateItem.class = className;
        } 
        else {
          this.markedDates.push({
            date: date,
            item: dateItem,
            class: className,
            inactive
          });
        }
        
        day += 24 * 60 * 60 * 1000;
      }
      
    },
    isUnacitve(time, historyChange){
      if(historyChange == null || historyChange.length == 0){
        return false;
      }
      // time = time.getTime();
      for(let i = 0; i < historyChange.length ; i++){
        let h = historyChange[i];
        let hTime = new Date(h.thoi_diem).getTime();
        if(time < hTime){
          return false;
        }
        if(time == hTime){
          return h.ngung_hoat_dong;
        }
        if(i == historyChange.length - 1){
          return h.ngung_hoat_dong;
        }
        if(time < new Date(historyChange[i+1].thoi_diem).getTime()){
          return h.ngung_hoat_dong;
        }
      }
    },
    changedMonth(date) {
      this.getDeclaredStatusCalendar(date);
    },
    dayClicked(date) {
      let selectedDay = this.markedDates.find(item => item.date == date.date);
      if (!selectedDay) return;
      if (selectedDay.item) {
        console.log("selectedDay.item.time", selectedDay.item.time)
        let time = moment(selectedDay.item.time);
        this.mData.selectedDay.date = time.format("DD-MM-YYYY");
        this.mData.selectedDay.time = time.format("HH:mm");
        this.mData.selectedDay.status = selectedDay.item.status;
        this.mData.selectedDay.count = selectedDay.item.count;
        this.mData.selectedDay.max = selectedDay.item.max;
        let loaiHinh = DataService.loaiHinhRegister.find(lh => lh.code == selectedDay.item.type);
        this.mData.selectedDay.type = loaiHinh ? loaiHinh.text : selectedDay.item.type;
      }
      else {
        let time = moment(selectedDay.date, "D-M-YYYY");
        this.mData.selectedDay.date = time.format("DD-MM-YYYY");
        this.mData.selectedDay.time = "";
        this.mData.selectedDay.status = null;
        this.mData.selectedDay.count = "";
        this.mData.selectedDay.max = "";
        this.mData.selectedDay.type = "";
      }
      this.mData.selectedDay.ngung_hoat_dong = selectedDay.inactive;
      
      this.mData.dialog.dayInfo = !selectedDay.inactive;
    },

    //Chuyển trạng thái hoạt động
    fn_chuyenTrangThaiHoatDong(trangThai){
      let message = "";
      if(trangThai){
        message = '<p>Bạn có chắc muốn chuyển trạng thái thành CƠ SỞ TẠM NGỪNG HOẠT ĐỘNG hay không?</p>' + 
                    '<p>Lưu ý: Bạn chỉ có thể chuyển lại trạng thái thành hoạt động sau ít nhất 7 ngày kể từ khi thực hiện chuyển đổi này!</p>';
      }else{
        message = '<p>Bạn có chắc muốn chuyển trạng thái thành HOẠT ĐỘNG hay không?</p>' + 
                    '<p>Lưu ý: Bạn chỉ có thể chuyển lại trạng thái thành hoạt động sau ít nhất 7 ngày kể từ khi thực hiện chuyển đổi này!</p>';
      }
      this.$confirm( message, '', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: LanguageService.lang.c_agree,
        cancelButtonText: LanguageService.lang.c_cancel,
        type: "warning",
      })
      .then(async () => {
        let data = {
          id: this.mData.dataForm.id,
          hoat_dong: {
            ngung_hoat_dong: trangThai
          }
        };
        try {
          await DiemDenAnToanApi.updateActive(data);
          // window.location.href = "admin/DangKyDDAT/list";
          location.reload();
        } catch (error) {
          console.log('ERROR : ',error.toString());
        }
        this.getStatusActive();
        this.$forceUpdate();
      })
      .catch(() => {
        this.mData.dataForm.hoat_dong.ngung_hoat_dong = !trangThai;
      });
    },
  },
  mounted() {
  },
  computed: {
    options() {
      return {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      };
    }
  },
};
</script>

<style lang="scss">
.lich-bieu {
  .fade-enter-active {
    transition: all 0.3s ease;
  }
  .fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .fade-enter,
  .fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
  .card-body {
    min-height: 86vh;
  }
  &.card {
    position: relative;
  }

  &.card::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 90%;
    height: 90%;
    background-image: url("~/img/safe-travel.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    opacity: 0.3;
    transform: translate(-50%,-50%);
  }

  .vfc-main-container {
    background-color: rgba(255,255,255,0.9);
  }

  .vfc-success {
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #09ff00;
    bottom: 3px;
    left: calc(50% - 15px);
  }

  .vfc-underline {
    -webkit-text-decoration: none!important;
    text-decoration: none!important;
  }

  .vfc-content {
    z-index: 1!important;
  }

  .vfc-week {
    .vfc-day {
      span.vfc-span-day {
        // background-color: #09ff00;

        &.vfc-today {
          width: 30px;
          line-height: 30px;
          color: #ffffff;
          background-color: #007BFF;
          border-radius: 100%;
          margin: 0 auto;
        }

        &.not-safe {
          background-color: #ff0404;
          color: #ffffff;
          cursor: pointer;

          &.not-declared {
            color: #ddd;
          }
        }

        &.risky {
          background-color: #f7e438;
          color: #ffffff;
          cursor: pointer;
        }

        &.safe {
          background-color: #4dbd74;
          color: #ffffff;
          cursor: pointer;
        }

        &.unactive {
          background-color: #808080;
          color: #ffffff;
          cursor: pointer;
        }
      }
    }
  }
}


.el-dialog{
  width: 420px;
  .el-dialog-title{
    width: 365px;
  }
  .el-dialog-title .title{
    font-size: 18px;
  }
  @media (max-width: 359px) {
    width: 296px;
    .el-dialog-title{
      width: 250px;
    }
  }
  @media (min-width: 360px) and (max-width: 410px) {
    width: 360px;
    .el-dialog-title{
      width: 300px;
    }
  }
  @media (min-width: 411px) and (max-width: 760px) {
    width: 390px;
    .el-dialog-title{
      width: 350px;
    }
  }
  @media (min-width: 760px) {
    width: 420px;
  }
}
// .el-message-box {
//   width: 95%;

//   @media (min-width: 576px) {
//     width: 420px;
//   }
// }
</style>
<style>
.status-title{
  font-style: italic;
  padding-bottom: 10px;
}
/* // .checkbox-inactive .el-checkbox__input+span.el-checkbox__label
// ,.checkbox-inactive .el-checkbox__input.is-disabled+span.el-checkbox__label{
//   color: #000;
//   text-transform: uppercase;
// }  */

.form-status{
  display: flex;
  /* // flex-direction: column;
  // margin-bottom: 20px; */
  z-index: 1000;
  position: relative;
}
.form-status .checkbox-active-lich{
  margin-right: 10px;
}
.form-status .checkbox-inactive-lich{
  line-height: 24px;
}
.form-status .checkbox-active-lich >span.el-radio__label{
  text-transform: uppercase;
  /* // color: rgb(63, 219, 16); */
}
.form-status .checkbox-active-lich .el-radio__input.is-disabled+span.el-radio__label{
  text-transform: uppercase;
  /* // color: rgb(63, 219, 16); */
}
.form-status .checkbox-active-lich .is-checked+span.el-radio__label{
  text-transform: uppercase;
  /* // color: rgb(63, 219, 16); */
  font-weight: bold;
}
.form-status .checkbox-inactive-lich >span.el-radio__label{
  text-transform: uppercase;
  /* // color: red; */
}
.form-status .checkbox-inactive-lich .is-checked+span.el-radio__label{
  text-transform: uppercase;
  /* // color: red; */
  font-weight: bold;
}
.form-status .checkbox-inactive-lich .el-radio__input.is-disabled+span.el-radio__label{
  text-transform: uppercase;
  /* // color: red; */
}
.form-status .el-form-item .checkbox-inactive-lich .el-radio__input.is-disabled.is-checked+span.el-radio__label{
  text-transform: uppercase;
  /* // color: red; */
  color: #409EFF;
}
.form-status .el-form-item .checkbox-active-lich .el-radio__input.is-disabled.is-checked+span.el-radio__label{
  text-transform: uppercase;
  /* // color: red; */
  color: #409EFF;
}
</style>